"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageInput = ImageInput;
var _ButtonBase2 = _interopRequireDefault(require("@mui/material/ButtonBase"));
var _Add2 = _interopRequireDefault(require("@mui/icons-material/Add"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _Close2 = _interopRequireDefault(require("@mui/icons-material/Close"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ImageInput({
  file,
  onChange
}) {
  const [value, setValue] = (0, _react.useState)('');
  const [previewUrl, setPreviewUrl] = (0, _react.useState)();
  const inputRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (file) {
      if ('url' in file) setPreviewUrl(file.url);else if (file instanceof File) setPreviewUrl(URL.createObjectURL(file));
    } else {
      setPreviewUrl(undefined);
    }
  }, [file]);
  function handleChange({
    target: {
      value,
      files
    }
  }) {
    setValue(value);
    const newFile = files?.[0];
    if (newFile && newFile.size > 2_000_000) {
      alert("L'image est trop lourde");
      setValue('');
      return;
    }
    if (newFile) setPreviewUrl(URL.createObjectURL(newFile));
    onChange(newFile || file);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("input", {
    accept: "image/*",
    onChange: handleChange,
    onClick: ({
      currentTarget
    }) => currentTarget.value = '',
    ref: inputRef,
    style: {
      display: 'none'
    },
    type: "file",
    value: value
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "flex-start",
    display: "flex",
    gap: 2
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    flexGrow: 1
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, "Privil\xE9giez une image au format paysage avec une largeur sup\xE9rieure \xE0 1500 pixels. La taille maximale par fichier est de 2 Mo.")), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    flexShrink: 0,
    width: 200
  }, previewUrl ? /*#__PURE__*/_react.default.createElement(_Box2.default, {
    position: "relative"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: previewUrl,
    style: {
      borderRadius: 8
    },
    width: "100%"
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    position: "absolute",
    right: 8,
    top: 8
  }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    onClick: () => onChange(null),
    size: "small",
    sx: {
      bgcolor: '#326AC2',
      color: '#fff',
      '&:hover': {
        bgcolor: (0, _styles.lighten)('#326AC2', 0.1)
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_Close2.default, null)))) : /*#__PURE__*/_react.default.createElement(_ButtonBase2.default, {
    onClick: () => inputRef.current?.click(),
    sx: {
      alignItems: 'center',
      bgcolor: '#528BE8',
      borderRadius: 2,
      color: '#fff',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      minHeight: 100,
      padding: 2,
      gap: 1,
      width: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    bgcolor: "#326AC2",
    borderRadius: 3,
    height: 24,
    width: 24
  }, /*#__PURE__*/_react.default.createElement(_Add2.default, null)), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    variant: "body2"
  }, "Ajouter une image")))));
}